var _objectWithoutProperties = require("/opt/build/repo/packages/hsey/node_modules/@babel/runtime/helpers/objectWithoutProperties");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("react-dom"), require("@emotion/core")) : "function" == typeof define && define.amd ? define(["exports", "react", "react-dom", "@emotion/core"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).Modal = {}, e.React, e.ReactDOM, e.core);
}(this, function (e, t, n, r) {
  "use strict";

  function o(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var a = o(t),
      s = o(n),
      _i = function i() {
    return (_i = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function c(e, t) {
    var n = {};

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
        t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
      }
    }

    return n;
  }

  function l(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function u(e) {
    if (e.__esModule) return e;
    var t = Object.defineProperty({}, "__esModule", {
      value: !0
    });
    return Object.keys(e).forEach(function (n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }), t;
  }

  function f(e) {
    var t = {
      exports: {}
    };
    return e(t, t.exports), t.exports;
  }

  var d = "function" == typeof Symbol && Symbol.for,
      p = d ? Symbol.for("react.element") : 60103,
      h = d ? Symbol.for("react.portal") : 60106,
      m = d ? Symbol.for("react.fragment") : 60107,
      y = d ? Symbol.for("react.strict_mode") : 60108,
      v = d ? Symbol.for("react.profiler") : 60114,
      b = d ? Symbol.for("react.provider") : 60109,
      g = d ? Symbol.for("react.context") : 60110,
      O = d ? Symbol.for("react.async_mode") : 60111,
      w = d ? Symbol.for("react.concurrent_mode") : 60111,
      C = d ? Symbol.for("react.forward_ref") : 60112,
      E = d ? Symbol.for("react.suspense") : 60113,
      S = d ? Symbol.for("react.suspense_list") : 60120,
      k = d ? Symbol.for("react.memo") : 60115,
      N = d ? Symbol.for("react.lazy") : 60116,
      _ = d ? Symbol.for("react.block") : 60121,
      A = d ? Symbol.for("react.fundamental") : 60117,
      x = d ? Symbol.for("react.responder") : 60118,
      j = d ? Symbol.for("react.scope") : 60119;

  function M(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;

      switch (t) {
        case p:
          switch (e = e.type) {
            case O:
            case w:
            case m:
            case v:
            case y:
            case E:
              return e;

            default:
              switch (e = e && e.$$typeof) {
                case g:
                case C:
                case N:
                case k:
                case b:
                  return e;

                default:
                  return t;
              }

          }

        case h:
          return t;
      }
    }
  }

  function P(e) {
    return M(e) === w;
  }

  var T = {
    AsyncMode: O,
    ConcurrentMode: w,
    ContextConsumer: g,
    ContextProvider: b,
    Element: p,
    ForwardRef: C,
    Fragment: m,
    Lazy: N,
    Memo: k,
    Portal: h,
    Profiler: v,
    StrictMode: y,
    Suspense: E,
    isAsyncMode: function isAsyncMode(e) {
      return P(e) || M(e) === O;
    },
    isConcurrentMode: P,
    isContextConsumer: function isContextConsumer(e) {
      return M(e) === g;
    },
    isContextProvider: function isContextProvider(e) {
      return M(e) === b;
    },
    isElement: function isElement(e) {
      return "object" == typeof e && null !== e && e.$$typeof === p;
    },
    isForwardRef: function isForwardRef(e) {
      return M(e) === C;
    },
    isFragment: function isFragment(e) {
      return M(e) === m;
    },
    isLazy: function isLazy(e) {
      return M(e) === N;
    },
    isMemo: function isMemo(e) {
      return M(e) === k;
    },
    isPortal: function isPortal(e) {
      return M(e) === h;
    },
    isProfiler: function isProfiler(e) {
      return M(e) === v;
    },
    isStrictMode: function isStrictMode(e) {
      return M(e) === y;
    },
    isSuspense: function isSuspense(e) {
      return M(e) === E;
    },
    isValidElementType: function isValidElementType(e) {
      return "string" == typeof e || "function" == typeof e || e === m || e === w || e === v || e === y || e === E || e === S || "object" == typeof e && null !== e && (e.$$typeof === N || e.$$typeof === k || e.$$typeof === b || e.$$typeof === g || e.$$typeof === C || e.$$typeof === A || e.$$typeof === x || e.$$typeof === j || e.$$typeof === _);
    },
    typeOf: M
  },
      R = f(function (e, t) {
    "production" !== process.env.NODE_ENV && function () {
      var e = "function" == typeof Symbol && Symbol.for,
          n = e ? Symbol.for("react.element") : 60103,
          r = e ? Symbol.for("react.portal") : 60106,
          o = e ? Symbol.for("react.fragment") : 60107,
          a = e ? Symbol.for("react.strict_mode") : 60108,
          s = e ? Symbol.for("react.profiler") : 60114,
          i = e ? Symbol.for("react.provider") : 60109,
          c = e ? Symbol.for("react.context") : 60110,
          l = e ? Symbol.for("react.async_mode") : 60111,
          u = e ? Symbol.for("react.concurrent_mode") : 60111,
          f = e ? Symbol.for("react.forward_ref") : 60112,
          d = e ? Symbol.for("react.suspense") : 60113,
          p = e ? Symbol.for("react.suspense_list") : 60120,
          h = e ? Symbol.for("react.memo") : 60115,
          m = e ? Symbol.for("react.lazy") : 60116,
          y = e ? Symbol.for("react.block") : 60121,
          v = e ? Symbol.for("react.fundamental") : 60117,
          b = e ? Symbol.for("react.responder") : 60118,
          g = e ? Symbol.for("react.scope") : 60119;

      function O(e) {
        if ("object" == typeof e && null !== e) {
          var t = e.$$typeof;

          switch (t) {
            case n:
              var p = e.type;

              switch (p) {
                case l:
                case u:
                case o:
                case s:
                case a:
                case d:
                  return p;

                default:
                  var y = p && p.$$typeof;

                  switch (y) {
                    case c:
                    case f:
                    case m:
                    case h:
                    case i:
                      return y;

                    default:
                      return t;
                  }

              }

            case r:
              return t;
          }
        }
      }

      var w = l,
          C = u,
          E = c,
          S = i,
          k = n,
          N = f,
          _ = o,
          A = m,
          x = h,
          j = r,
          M = s,
          P = a,
          T = d,
          R = !1;

      function D(e) {
        return O(e) === u;
      }

      t.AsyncMode = w, t.ConcurrentMode = C, t.ContextConsumer = E, t.ContextProvider = S, t.Element = k, t.ForwardRef = N, t.Fragment = _, t.Lazy = A, t.Memo = x, t.Portal = j, t.Profiler = M, t.StrictMode = P, t.Suspense = T, t.isAsyncMode = function (e) {
        return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(e) || O(e) === l;
      }, t.isConcurrentMode = D, t.isContextConsumer = function (e) {
        return O(e) === c;
      }, t.isContextProvider = function (e) {
        return O(e) === i;
      }, t.isElement = function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === n;
      }, t.isForwardRef = function (e) {
        return O(e) === f;
      }, t.isFragment = function (e) {
        return O(e) === o;
      }, t.isLazy = function (e) {
        return O(e) === m;
      }, t.isMemo = function (e) {
        return O(e) === h;
      }, t.isPortal = function (e) {
        return O(e) === r;
      }, t.isProfiler = function (e) {
        return O(e) === s;
      }, t.isStrictMode = function (e) {
        return O(e) === a;
      }, t.isSuspense = function (e) {
        return O(e) === d;
      }, t.isValidElementType = function (e) {
        return "string" == typeof e || "function" == typeof e || e === o || e === u || e === s || e === a || e === d || e === p || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === h || e.$$typeof === i || e.$$typeof === c || e.$$typeof === f || e.$$typeof === v || e.$$typeof === b || e.$$typeof === g || e.$$typeof === y);
      }, t.typeOf = O;
    }();
  }),
      D = f(function (e) {
    "production" === process.env.NODE_ENV ? e.exports = T : e.exports = R;
  }),
      F = Object.getOwnPropertySymbols,
      $ = Object.prototype.hasOwnProperty,
      I = Object.prototype.propertyIsEnumerable;

  function U(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  var L = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, o = U(e), a = 1; a < arguments.length; a++) {
      for (var s in n = Object(arguments[a])) {
        $.call(n, s) && (o[s] = n[s]);
      }

      if (F) {
        r = F(n);

        for (var i = 0; i < r.length; i++) {
          I.call(n, r[i]) && (o[r[i]] = n[r[i]]);
        }
      }
    }

    return o;
  },
      W = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
      V = function V() {};

  if ("production" !== process.env.NODE_ENV) {
    var q = W,
        H = {},
        z = Function.call.bind(Object.prototype.hasOwnProperty);

    V = function V(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);

      try {
        throw new Error(t);
      } catch (e) {}
    };
  }

  function B(e, t, n, r, o) {
    if ("production" !== process.env.NODE_ENV) for (var a in e) {
      if (z(e, a)) {
        var s;

        try {
          if ("function" != typeof e[a]) {
            var i = Error((r || "React class") + ": " + n + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.");
            throw i.name = "Invariant Violation", i;
          }

          s = e[a](t, a, r, n, null, q);
        } catch (e) {
          s = e;
        }

        if (!s || s instanceof Error || V((r || "React class") + ": type specification of " + n + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), s instanceof Error && !(s.message in H)) {
          H[s.message] = !0;
          var c = o ? o() : "";
          V("Failed " + n + " type: " + s.message + (null != c ? c : ""));
        }
      }
    }
  }

  B.resetWarningCache = function () {
    "production" !== process.env.NODE_ENV && (H = {});
  };

  var Y = B,
      K = Function.call.bind(Object.prototype.hasOwnProperty),
      J = function J() {};

  function G() {
    return null;
  }

  "production" !== process.env.NODE_ENV && (J = function J(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  });

  var Q = function Q(e, t) {
    var n = "function" == typeof Symbol && Symbol.iterator;
    var r = "<<anonymous>>",
        o = {
      array: c("array"),
      bool: c("boolean"),
      func: c("function"),
      number: c("number"),
      object: c("object"),
      string: c("string"),
      symbol: c("symbol"),
      any: i(G),
      arrayOf: function arrayOf(e) {
        return i(function (t, n, r, o, a) {
          if ("function" != typeof e) return new s("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
          var i = t[n];
          if (!Array.isArray(i)) return new s("Invalid " + o + " `" + a + "` of type `" + u(i) + "` supplied to `" + r + "`, expected an array.");

          for (var c = 0; c < i.length; c++) {
            var l = e(i, c, r, o, a + "[" + c + "]", W);
            if (l instanceof Error) return l;
          }

          return null;
        });
      },
      element: i(function (t, n, r, o, a) {
        var i = t[n];
        return e(i) ? null : new s("Invalid " + o + " `" + a + "` of type `" + u(i) + "` supplied to `" + r + "`, expected a single ReactElement.");
      }),
      elementType: i(function (e, t, n, r, o) {
        var a = e[t];
        return D.isValidElementType(a) ? null : new s("Invalid " + r + " `" + o + "` of type `" + u(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(e) {
        return i(function (t, n, o, a, i) {
          if (!(t[n] instanceof e)) {
            var c = e.name || r;
            return new s("Invalid " + a + " `" + i + "` of type `" + (((l = t[n]).constructor && l.constructor.name ? l.constructor.name : r) + "` supplied to `") + o + "`, expected instance of `" + c + "`.");
          }

          var l;
          return null;
        });
      },
      node: i(function (e, t, n, r, o) {
        return l(e[t]) ? null : new s("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(e) {
        return i(function (t, n, r, o, a) {
          if ("function" != typeof e) return new s("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
          var i = t[n],
              c = u(i);
          if ("object" !== c) return new s("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected an object.");

          for (var l in i) {
            if (K(i, l)) {
              var f = e(i, l, r, o, a + "." + l, W);
              if (f instanceof Error) return f;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && J(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), G;

        function t(t, n, r, o, i) {
          for (var c = t[n], l = 0; l < e.length; l++) {
            if (a(c, e[l])) return null;
          }

          var u = JSON.stringify(e, function (e, t) {
            return "symbol" === f(t) ? String(t) : t;
          });
          return new s("Invalid " + o + " `" + i + "` of value `" + String(c) + "` supplied to `" + r + "`, expected one of " + u + ".");
        }

        return i(t);
      },
      oneOfType: function oneOfType(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && J("Invalid argument supplied to oneOfType, expected an instance of array."), G;

        for (var t = 0; t < e.length; t++) {
          var n = e[t];
          if ("function" != typeof n) return J("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + d(n) + " at index " + t + "."), G;
        }

        return i(function (t, n, r, o, a) {
          for (var i = 0; i < e.length; i++) {
            if (null == (0, e[i])(t, n, r, o, a, W)) return null;
          }

          return new s("Invalid " + o + " `" + a + "` supplied to `" + r + "`.");
        });
      },
      shape: function shape(e) {
        return i(function (t, n, r, o, a) {
          var i = t[n],
              c = u(i);
          if ("object" !== c) return new s("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");

          for (var l in e) {
            var f = e[l];

            if (f) {
              var d = f(i, l, r, o, a + "." + l, W);
              if (d) return d;
            }
          }

          return null;
        });
      },
      exact: function exact(e) {
        return i(function (t, n, r, o, a) {
          var i = t[n],
              c = u(i);
          if ("object" !== c) return new s("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");
          var l = L({}, t[n], e);

          for (var f in l) {
            var d = e[f];
            if (!d) return new s("Invalid " + o + " `" + a + "` key `" + f + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var p = d(i, f, r, o, a + "." + f, W);
            if (p) return p;
          }

          return null;
        });
      }
    };

    function a(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }

    function s(e) {
      this.message = e, this.stack = "";
    }

    function i(e) {
      if ("production" !== process.env.NODE_ENV) var n = {},
          o = 0;

      function a(a, i, c, l, u, f, d) {
        if (l = l || r, f = f || c, d !== W) {
          if (t) {
            var p = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw p.name = "Invariant Violation", p;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var h = l + ":" + c;
            !n[h] && o < 3 && (J("You are manually calling a React.PropTypes validation function for the `" + f + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[h] = !0, o++);
          }
        }

        return null == i[c] ? a ? null === i[c] ? new s("The " + u + " `" + f + "` is marked as required in `" + l + "`, but its value is `null`.") : new s("The " + u + " `" + f + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(i, c, l, u, f);
      }

      var i = a.bind(null, !1);
      return i.isRequired = a.bind(null, !0), i;
    }

    function c(e) {
      return i(function (t, n, r, o, a, i) {
        var c = t[n];
        return u(c) !== e ? new s("Invalid " + o + " `" + a + "` of type `" + f(c) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
      });
    }

    function l(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !t;

        case "object":
          if (Array.isArray(t)) return t.every(l);
          if (null === t || e(t)) return !0;

          var r = function (e) {
            var t = e && (n && e[n] || e["@@iterator"]);
            if ("function" == typeof t) return t;
          }(t);

          if (!r) return !1;
          var o,
              a = r.call(t);

          if (r !== t.entries) {
            for (; !(o = a.next()).done;) {
              if (!l(o.value)) return !1;
            }
          } else for (; !(o = a.next()).done;) {
            var s = o.value;
            if (s && !l(s[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function u(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
      }(t, e) ? "symbol" : t;
    }

    function f(e) {
      if (null == e) return "" + e;
      var t = u(e);

      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }

      return t;
    }

    function d(e) {
      var t = f(e);

      switch (t) {
        case "array":
        case "object":
          return "an " + t;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;

        default:
          return t;
      }
    }

    return s.prototype = Error.prototype, o.checkPropTypes = Y, o.resetWarningCache = Y.resetWarningCache, o.PropTypes = o, o;
  };

  function X() {}

  function Z() {}

  Z.resetWarningCache = X;

  var ee,
      te = f(function (e) {
    if ("production" !== process.env.NODE_ENV) {
      var t = D;
      e.exports = Q(t.isElement, !0);
    } else e.exports = function () {
      function e(e, t, n, r, o, a) {
        if (a !== W) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: Z,
        resetWarningCache: X
      };
      return n.PropTypes = n, n;
    }();
  }),
      ne = f(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return [].slice.call(e.querySelectorAll("*"), 0).filter(a);
    };
    var n = /input|select|textarea|button|object/;

    function r(e) {
      var t = e.offsetWidth <= 0 && e.offsetHeight <= 0;
      if (t && !e.innerHTML) return !0;

      try {
        var n = window.getComputedStyle(e);
        return t ? "visible" !== n.getPropertyValue("overflow") || e.scrollWidth <= 0 && e.scrollHeight <= 0 : "none" == n.getPropertyValue("display");
      } catch (e) {
        return console.warn("Failed to inspect element style"), !1;
      }
    }

    function o(e, t) {
      var o = e.nodeName.toLowerCase();
      return (n.test(o) && !e.disabled || "a" === o && e.href || t) && function (e) {
        for (var t = e; t && t !== document.body;) {
          if (r(t)) return !1;
          t = t.parentNode;
        }

        return !0;
      }(e);
    }

    function a(e) {
      var t = e.getAttribute("tabindex");
      null === t && (t = void 0);
      var n = isNaN(t);
      return (n || t >= 0) && o(e, !n);
    }

    e.exports = t.default;
  }),
      re = function re() {
    pe = [];
  },
      oe = function oe() {
    if ("production" === process.env.NODE_ENV) return;
    console.log("focusManager ----------"), pe.forEach(function (e) {
      var t = e || {};
      console.log(t.nodeName, t.className, t.id);
    }), console.log("end focusManager ----------");
  },
      ae = ye,
      se = ve,
      ie = function ie() {
    pe.push(document.activeElement);
  },
      ce = function ce() {
    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
        t = null;

    try {
      return void (0 !== pe.length && (t = pe.pop()).focus({
        preventScroll: e
      }));
    } catch (e) {
      console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
    }
  },
      le = function le() {
    pe.length > 0 && pe.pop();
  },
      ue = function ue(e) {
    he = e, window.addEventListener ? (window.addEventListener("blur", ye, !1), document.addEventListener("focus", ve, !0)) : (window.attachEvent("onBlur", ye), document.attachEvent("onFocus", ve));
  },
      fe = function fe() {
    he = null, window.addEventListener ? (window.removeEventListener("blur", ye), document.removeEventListener("focus", ve)) : (window.detachEvent("onBlur", ye), document.detachEvent("onFocus", ve));
  },
      de = (ee = ne) && ee.__esModule ? ee : {
    default: ee
  };

  var pe = [],
      he = null,
      me = !1;

  function ye() {
    me = !0;
  }

  function ve() {
    if (me) {
      if (me = !1, !he) return;
      setTimeout(function () {
        he.contains(document.activeElement) || ((0, de.default)(he)[0] || he).focus();
      }, 0);
    }
  }

  var be = Object.defineProperty({
    resetState: re,
    log: oe,
    handleBlur: ae,
    handleFocus: se,
    markForFocusLater: ie,
    returnFocus: ce,
    popWithoutFocus: le,
    setupScopedFocus: ue,
    teardownScopedFocus: fe
  }, "__esModule", {
    value: !0
  }),
      ge = f(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e, t) {
      var r = (0, n.default)(e);
      if (!r.length) return void t.preventDefault();
      var o = void 0,
          a = t.shiftKey,
          s = r[0],
          i = r[r.length - 1];

      if (e === document.activeElement) {
        if (!a) return;
        o = i;
      }

      i !== document.activeElement || a || (o = s);
      s === document.activeElement && a && (o = i);
      if (o) return t.preventDefault(), void o.focus();
      var c = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
      if (null == c || "Chrome" == c[1] || null != /\biPod\b|\biPad\b/g.exec(navigator.userAgent)) return;
      var l = r.indexOf(document.activeElement);
      l > -1 && (l += a ? -1 : 1);
      if (void 0 === (o = r[l])) return t.preventDefault(), void (o = a ? i : s).focus();
      t.preventDefault(), o.focus();
    };

    var n = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(ne);

    e.exports = t.default;
  }),
      Oe = function Oe() {};

  if ("production" !== process.env.NODE_ENV) {
    var we = function we(e, t) {
      var n = arguments.length;
      t = new Array(n > 1 ? n - 1 : 0);

      for (var r = 1; r < n; r++) {
        t[r - 1] = arguments[r];
      }

      var o = 0,
          a = "Warning: " + e.replace(/%s/g, function () {
        return t[o++];
      });
      "undefined" != typeof console && console.error(a);

      try {
        throw new Error(a);
      } catch (e) {}
    };

    Oe = function Oe(e, t, n) {
      var r = arguments.length;
      n = new Array(r > 2 ? r - 2 : 0);

      for (var o = 2; o < r; o++) {
        n[o - 2] = arguments[o];
      }

      if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
      e || we.apply(null, [t].concat(n));
    };
  }

  var Ce = Oe,
      Ee = f(function (e) {
    var t, n;
    t = !("undefined" == typeof window || !window.document || !window.document.createElement), n = {
      canUseDOM: t,
      canUseWorkers: "undefined" != typeof Worker,
      canUseEventListeners: t && !(!window.addEventListener && !window.attachEvent),
      canUseViewport: t && !!window.screen
    }, e.exports ? e.exports = n : window.ExecutionEnvironment = n;
  }),
      Se = f(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.canUseDOM = t.SafeNodeList = t.SafeHTMLCollection = void 0;

    var n = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(Ee).default,
        r = n.canUseDOM ? window.HTMLElement : {};

    t.SafeHTMLCollection = n.canUseDOM ? window.HTMLCollection : {}, t.SafeNodeList = n.canUseDOM ? window.NodeList : {}, t.canUseDOM = n.canUseDOM, t.default = r;
  }),
      ke = function ke() {
    Re && (Re.removeAttribute ? Re.removeAttribute("aria-hidden") : null != Re.length ? Re.forEach(function (e) {
      return e.removeAttribute("aria-hidden");
    }) : document.querySelectorAll(Re).forEach(function (e) {
      return e.removeAttribute("aria-hidden");
    }));
    Re = null;
  },
      Ne = function Ne() {
    if ("production" === process.env.NODE_ENV) return;
    var e = Re || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  },
      _e = De,
      Ae = function Ae(e) {
    var t = e;

    if ("string" == typeof t && Se.canUseDOM) {
      var n = document.querySelectorAll(t);
      De(n, t), t = n;
    }

    return Re = t || Re;
  },
      xe = Fe,
      je = function je(e) {
    var t = !0,
        n = !1,
        r = void 0;

    try {
      for (var o, a = Fe(e)[Symbol.iterator](); !(t = (o = a.next()).done); t = !0) {
        o.value.setAttribute("aria-hidden", "true");
      }
    } catch (e) {
      n = !0, r = e;
    } finally {
      try {
        !t && a.return && a.return();
      } finally {
        if (n) throw r;
      }
    }
  },
      Me = function Me(e) {
    var t = !0,
        n = !1,
        r = void 0;

    try {
      for (var o, a = Fe(e)[Symbol.iterator](); !(t = (o = a.next()).done); t = !0) {
        o.value.removeAttribute("aria-hidden");
      }
    } catch (e) {
      n = !0, r = e;
    } finally {
      try {
        !t && a.return && a.return();
      } finally {
        if (n) throw r;
      }
    }
  },
      Pe = function Pe() {
    Re = null;
  },
      Te = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(Ce);

  var Re = null;

  function De(e, t) {
    if (!e || !e.length) throw new Error("react-modal: No elements were found for selector " + t + ".");
  }

  function Fe(e) {
    var t = e || Re;
    return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, Te.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
  }

  var $e = Object.defineProperty({
    resetState: ke,
    log: Ne,
    assertNodeList: _e,
    setElement: Ae,
    validateElement: xe,
    hide: je,
    show: Me,
    documentNotReadyOrSSRTesting: Pe
  }, "__esModule", {
    value: !0
  }),
      Ie = f(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.resetState = function () {
      var e = document.getElementsByTagName("html")[0];

      for (var t in n) {
        o(e, n[t]);
      }

      var a = document.body;

      for (var s in r) {
        o(a, r[s]);
      }

      n = {}, r = {};
    }, t.log = function () {
      if ("production" === process.env.NODE_ENV) return;
      var e = document.getElementsByTagName("html")[0].className,
          t = "Show tracked classes:\n\n";

      for (var o in t += "<html /> (" + e + "):\n", n) {
        t += "  " + o + " " + n[o] + "\n";
      }

      for (var a in e = document.body.className, t += "\n\ndoc.body (" + e + "):\n", r) {
        t += "  " + a + " " + r[a] + "\n";
      }

      t += "\n", console.log(t);
    };
    var n = {},
        r = {};

    function o(e, t) {
      e.classList.remove(t);
    }

    t.add = function (e, t) {
      return o = e.classList, a = "html" == e.nodeName.toLowerCase() ? n : r, void t.split(" ").forEach(function (e) {
        !function (e, t) {
          e[t] || (e[t] = 0), e[t] += 1;
        }(a, e), o.add(e);
      });
      var o, a;
    }, t.remove = function (e, t) {
      return o = e.classList, a = "html" == e.nodeName.toLowerCase() ? n : r, void t.split(" ").forEach(function (e) {
        !function (e, t) {
          e[t] && (e[t] -= 1);
        }(a, e), 0 === a[e] && o.remove(e);
      });
      var o, a;
    };
  }),
      Ue = function Ue() {
    console.log("portalOpenInstances ----------"), console.log(Ve.openInstances.length), Ve.openInstances.forEach(function (e) {
      return console.log(e);
    }), console.log("end portalOpenInstances ----------");
  },
      Le = function Le() {
    Ve = new We();
  };

  var We = function e() {
    var t = this;
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, e), this.register = function (e) {
      -1 === t.openInstances.indexOf(e) ? (t.openInstances.push(e), t.emit("register")) : "production" !== process.env.NODE_ENV && console.warn("React-Modal: Cannot register modal instance that's already open");
    }, this.deregister = function (e) {
      var n = t.openInstances.indexOf(e);
      -1 !== n ? (t.openInstances.splice(n, 1), t.emit("deregister")) : "production" !== process.env.NODE_ENV && console.warn("React-Modal: Unable to deregister " + e + " as it was never registered");
    }, this.subscribe = function (e) {
      t.subscribers.push(e);
    }, this.emit = function (e) {
      t.subscribers.forEach(function (n) {
        return n(e, t.openInstances.slice());
      });
    }, this.openInstances = [], this.subscribers = [];
  },
      Ve = new We();

  var qe = Ve,
      He = Object.defineProperty({
    log: Ue,
    resetState: Le,
    default: qe
  }, "__esModule", {
    value: !0
  }),
      ze = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }(He);

  var Be = void 0,
      Ye = void 0,
      Ke = [];

  function Je() {
    0 !== Ke.length ? Ke[Ke.length - 1].focusContent() : "production" !== process.env.NODE_ENV && console.warn("React-Modal: Open instances > 0 expected");
  }

  ze.default.subscribe(function (e, t) {
    Be || Ye || ((Be = document.createElement("div")).setAttribute("data-react-modal-body-trap", ""), Be.style.position = "absolute", Be.style.opacity = "0", Be.setAttribute("tabindex", "0"), Be.addEventListener("focus", Je), (Ye = Be.cloneNode()).addEventListener("focus", Je)), (Ke = t).length > 0 ? (document.body.firstChild !== Be && document.body.insertBefore(Be, document.body.firstChild), document.body.lastChild !== Ye && document.body.appendChild(Ye)) : (Be.parentElement && Be.parentElement.removeChild(Be), Ye.parentElement && Ye.parentElement.removeChild(Ye));
  });
  var Ge = f(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        s = h(te),
        i = p(be),
        c = h(ge),
        l = p($e),
        u = p(Ie),
        f = h(Se),
        d = h(He);

    function p(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }

    function h(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var m = {
      overlay: "ReactModal__Overlay",
      content: "ReactModal__Content"
    },
        y = 0,
        v = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

        return n.setOverlayRef = function (e) {
          n.overlay = e, n.props.overlayRef && n.props.overlayRef(e);
        }, n.setContentRef = function (e) {
          n.content = e, n.props.contentRef && n.props.contentRef(e);
        }, n.afterClose = function () {
          var e = n.props,
              t = e.appElement,
              r = e.ariaHideApp,
              o = e.htmlOpenClassName,
              a = e.bodyOpenClassName;
          a && u.remove(document.body, a), o && u.remove(document.getElementsByTagName("html")[0], o), r && y > 0 && 0 === (y -= 1) && l.show(t), n.props.shouldFocusAfterRender && (n.props.shouldReturnFocusAfterClose ? (i.returnFocus(n.props.preventScroll), i.teardownScopedFocus()) : i.popWithoutFocus()), n.props.onAfterClose && n.props.onAfterClose(), d.default.deregister(n);
        }, n.open = function () {
          n.beforeOpen(), n.state.afterOpen && n.state.beforeClose ? (clearTimeout(n.closeTimer), n.setState({
            beforeClose: !1
          })) : (n.props.shouldFocusAfterRender && (i.setupScopedFocus(n.node), i.markForFocusLater()), n.setState({
            isOpen: !0
          }, function () {
            n.openAnimationFrame = requestAnimationFrame(function () {
              n.setState({
                afterOpen: !0
              }), n.props.isOpen && n.props.onAfterOpen && n.props.onAfterOpen({
                overlayEl: n.overlay,
                contentEl: n.content
              });
            });
          }));
        }, n.close = function () {
          n.props.closeTimeoutMS > 0 ? n.closeWithTimeout() : n.closeWithoutTimeout();
        }, n.focusContent = function () {
          return n.content && !n.contentHasFocus() && n.content.focus({
            preventScroll: !0
          });
        }, n.closeWithTimeout = function () {
          var e = Date.now() + n.props.closeTimeoutMS;
          n.setState({
            beforeClose: !0,
            closesAt: e
          }, function () {
            n.closeTimer = setTimeout(n.closeWithoutTimeout, n.state.closesAt - Date.now());
          });
        }, n.closeWithoutTimeout = function () {
          n.setState({
            beforeClose: !1,
            isOpen: !1,
            afterOpen: !1,
            closesAt: null
          }, n.afterClose);
        }, n.handleKeyDown = function (e) {
          9 === e.keyCode && (0, c.default)(n.content, e), n.props.shouldCloseOnEsc && 27 === e.keyCode && (e.stopPropagation(), n.requestClose(e));
        }, n.handleOverlayOnClick = function (e) {
          null === n.shouldClose && (n.shouldClose = !0), n.shouldClose && n.props.shouldCloseOnOverlayClick && (n.ownerHandlesClose() ? n.requestClose(e) : n.focusContent()), n.shouldClose = null;
        }, n.handleContentOnMouseUp = function () {
          n.shouldClose = !1;
        }, n.handleOverlayOnMouseDown = function (e) {
          n.props.shouldCloseOnOverlayClick || e.target != n.overlay || e.preventDefault();
        }, n.handleContentOnClick = function () {
          n.shouldClose = !1;
        }, n.handleContentOnMouseDown = function () {
          n.shouldClose = !1;
        }, n.requestClose = function (e) {
          return n.ownerHandlesClose() && n.props.onRequestClose(e);
        }, n.ownerHandlesClose = function () {
          return n.props.onRequestClose;
        }, n.shouldBeClosed = function () {
          return !n.state.isOpen && !n.state.beforeClose;
        }, n.contentHasFocus = function () {
          return document.activeElement === n.content || n.content.contains(document.activeElement);
        }, n.buildClassName = function (e, t) {
          var o = "object" === (void 0 === t ? "undefined" : r(t)) ? t : {
            base: m[e],
            afterOpen: m[e] + "--after-open",
            beforeClose: m[e] + "--before-close"
          },
              a = o.base;
          return n.state.afterOpen && (a = a + " " + o.afterOpen), n.state.beforeClose && (a = a + " " + o.beforeClose), "string" == typeof t && t ? a + " " + t : a;
        }, n.attributesFromObject = function (e, t) {
          return Object.keys(t).reduce(function (n, r) {
            return n[e + "-" + r] = t[r], n;
          }, {});
        }, n.state = {
          afterOpen: !1,
          beforeClose: !1
        }, n.shouldClose = null, n.moveFromContentToOverlay = null, n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, [{
        key: "componentDidMount",
        value: function value() {
          this.props.isOpen && this.open();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t) {
          "production" !== process.env.NODE_ENV && (e.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), e.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !e.isOpen ? this.open() : !this.props.isOpen && e.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !t.isOpen && this.focusContent();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
        }
      }, {
        key: "beforeOpen",
        value: function value() {
          var e = this.props,
              t = e.appElement,
              n = e.ariaHideApp,
              r = e.htmlOpenClassName,
              o = e.bodyOpenClassName;
          o && u.add(document.body, o), r && u.add(document.getElementsByTagName("html")[0], r), n && (y += 1, l.hide(t)), d.default.register(this);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.id,
              r = e.className,
              o = e.overlayClassName,
              a = e.defaultStyles,
              s = e.children,
              i = r ? {} : a.content,
              c = o ? {} : a.overlay;
          if (this.shouldBeClosed()) return null;
          var l = {
            ref: this.setOverlayRef,
            className: this.buildClassName("overlay", o),
            style: n({}, c, this.props.style.overlay),
            onClick: this.handleOverlayOnClick,
            onMouseDown: this.handleOverlayOnMouseDown
          },
              u = n({
            id: t,
            ref: this.setContentRef,
            style: n({}, i, this.props.style.content),
            className: this.buildClassName("content", r),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", n({
            modal: !0
          }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
              f = this.props.contentElement(u, s);
          return this.props.overlayElement(l, f);
        }
      }]), t;
    }(a.default.Component);

    v.defaultProps = {
      style: {
        overlay: {},
        content: {}
      },
      defaultStyles: {}
    }, v.propTypes = {
      isOpen: s.default.bool.isRequired,
      defaultStyles: s.default.shape({
        content: s.default.object,
        overlay: s.default.object
      }),
      style: s.default.shape({
        content: s.default.object,
        overlay: s.default.object
      }),
      className: s.default.oneOfType([s.default.string, s.default.object]),
      overlayClassName: s.default.oneOfType([s.default.string, s.default.object]),
      bodyOpenClassName: s.default.string,
      htmlOpenClassName: s.default.string,
      ariaHideApp: s.default.bool,
      appElement: s.default.oneOfType([s.default.instanceOf(f.default), s.default.instanceOf(Se.SafeHTMLCollection), s.default.instanceOf(Se.SafeNodeList), s.default.arrayOf(s.default.instanceOf(f.default))]),
      onAfterOpen: s.default.func,
      onAfterClose: s.default.func,
      onRequestClose: s.default.func,
      closeTimeoutMS: s.default.number,
      shouldFocusAfterRender: s.default.bool,
      shouldCloseOnOverlayClick: s.default.bool,
      shouldReturnFocusAfterClose: s.default.bool,
      preventScroll: s.default.bool,
      role: s.default.string,
      contentLabel: s.default.string,
      aria: s.default.object,
      data: s.default.object,
      children: s.default.node,
      shouldCloseOnEsc: s.default.bool,
      overlayRef: s.default.func,
      contentRef: s.default.func,
      id: s.default.string,
      overlayElement: s.default.func,
      contentElement: s.default.func,
      testId: s.default.string
    }, t.default = v, e.exports = t.default;
  });

  function Qe() {
    var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
    null != e && this.setState(e);
  }

  function Xe(e) {
    this.setState(function (t) {
      var n = this.constructor.getDerivedStateFromProps(e, t);
      return null != n ? n : null;
    }.bind(this));
  }

  function Ze(e, t) {
    try {
      var n = this.props,
          r = this.state;
      this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, r);
    } finally {
      this.props = n, this.state = r;
    }
  }

  Qe.__suppressDeprecationWarning = !0, Xe.__suppressDeprecationWarning = !0, Ze.__suppressDeprecationWarning = !0;
  var et = u(Object.freeze({
    __proto__: null,
    polyfill: function polyfill(e) {
      var t = e.prototype;
      if (!t || !t.isReactComponent) throw new Error("Can only polyfill class components");
      if ("function" != typeof e.getDerivedStateFromProps && "function" != typeof t.getSnapshotBeforeUpdate) return e;
      var n = null,
          r = null,
          o = null;

      if ("function" == typeof t.componentWillMount ? n = "componentWillMount" : "function" == typeof t.UNSAFE_componentWillMount && (n = "UNSAFE_componentWillMount"), "function" == typeof t.componentWillReceiveProps ? r = "componentWillReceiveProps" : "function" == typeof t.UNSAFE_componentWillReceiveProps && (r = "UNSAFE_componentWillReceiveProps"), "function" == typeof t.componentWillUpdate ? o = "componentWillUpdate" : "function" == typeof t.UNSAFE_componentWillUpdate && (o = "UNSAFE_componentWillUpdate"), null !== n || null !== r || null !== o) {
        var a = e.displayName || e.name,
            s = "function" == typeof e.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + a + " uses " + s + " but also contains the following legacy lifecycles:" + (null !== n ? "\n  " + n : "") + (null !== r ? "\n  " + r : "") + (null !== o ? "\n  " + o : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
      }

      if ("function" == typeof e.getDerivedStateFromProps && (t.componentWillMount = Qe, t.componentWillReceiveProps = Xe), "function" == typeof t.getSnapshotBeforeUpdate) {
        if ("function" != typeof t.componentDidUpdate) throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        t.componentWillUpdate = Ze;
        var i = t.componentDidUpdate;

        t.componentDidUpdate = function (e, t, n) {
          var r = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : n;
          i.call(this, e, t, r);
        };
      }

      return e;
    }
  })),
      tt = f(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.bodyOpenClassName = t.portalClassName = void 0;

    var n = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        r = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        o = d(a.default),
        i = d(s.default),
        c = d(te),
        l = d(Ge),
        u = function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }($e),
        f = d(Se);

    function d(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function p(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function h(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    var m = t.portalClassName = "ReactModalPortal",
        y = t.bodyOpenClassName = "ReactModal__Body--open",
        v = Se.canUseDOM && void 0 !== i.default.createPortal,
        b = function b(e) {
      return document.createElement(e);
    },
        g = function g() {
      return v ? i.default.createPortal : i.default.unstable_renderSubtreeIntoContainer;
    };

    function O(e) {
      return e();
    }

    var w = function (e) {
      function t() {
        var e, r, a;
        p(this, t);

        for (var s = arguments.length, c = Array(s), u = 0; u < s; u++) {
          c[u] = arguments[u];
        }

        return r = a = h(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), a.removePortal = function () {
          !v && i.default.unmountComponentAtNode(a.node);
          var e = O(a.props.parentSelector);
          e && e.contains(a.node) ? e.removeChild(a.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, a.portalRef = function (e) {
          a.portal = e;
        }, a.renderPortal = function (e) {
          var r = g()(a, o.default.createElement(l.default, n({
            defaultStyles: t.defaultStyles
          }, e)), a.node);
          a.portalRef(r);
        }, h(a, r);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), r(t, [{
        key: "componentDidMount",
        value: function value() {
          Se.canUseDOM && (v || (this.node = b("div")), this.node.className = this.props.portalClassName, O(this.props.parentSelector).appendChild(this.node), !v && this.renderPortal(this.props));
        }
      }, {
        key: "getSnapshotBeforeUpdate",
        value: function value(e) {
          return {
            prevParent: O(e.parentSelector),
            nextParent: O(this.props.parentSelector)
          };
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t, n) {
          if (Se.canUseDOM) {
            var r = this.props,
                o = r.isOpen,
                a = r.portalClassName;
            e.portalClassName !== a && (this.node.className = a);
            var s = n.prevParent,
                i = n.nextParent;
            i !== s && (s.removeChild(this.node), i.appendChild(this.node)), (e.isOpen || o) && !v && this.renderPortal(this.props);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          if (Se.canUseDOM && this.node && this.portal) {
            var e = this.portal.state,
                t = Date.now(),
                n = e.isOpen && this.props.closeTimeoutMS && (e.closesAt || t + this.props.closeTimeoutMS);
            n ? (e.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, n - t)) : this.removePortal();
          }
        }
      }, {
        key: "render",
        value: function value() {
          return Se.canUseDOM && v ? (!this.node && v && (this.node = b("div")), g()(o.default.createElement(l.default, n({
            ref: this.portalRef,
            defaultStyles: t.defaultStyles
          }, this.props)), this.node)) : null;
        }
      }], [{
        key: "setAppElement",
        value: function value(e) {
          u.setElement(e);
        }
      }]), t;
    }(a.default.Component);

    w.propTypes = {
      isOpen: c.default.bool.isRequired,
      style: c.default.shape({
        content: c.default.object,
        overlay: c.default.object
      }),
      portalClassName: c.default.string,
      bodyOpenClassName: c.default.string,
      htmlOpenClassName: c.default.string,
      className: c.default.oneOfType([c.default.string, c.default.shape({
        base: c.default.string.isRequired,
        afterOpen: c.default.string.isRequired,
        beforeClose: c.default.string.isRequired
      })]),
      overlayClassName: c.default.oneOfType([c.default.string, c.default.shape({
        base: c.default.string.isRequired,
        afterOpen: c.default.string.isRequired,
        beforeClose: c.default.string.isRequired
      })]),
      appElement: c.default.oneOfType([c.default.instanceOf(f.default), c.default.instanceOf(Se.SafeHTMLCollection), c.default.instanceOf(Se.SafeNodeList), c.default.arrayOf(c.default.instanceOf(f.default))]),
      onAfterOpen: c.default.func,
      onRequestClose: c.default.func,
      closeTimeoutMS: c.default.number,
      ariaHideApp: c.default.bool,
      shouldFocusAfterRender: c.default.bool,
      shouldCloseOnOverlayClick: c.default.bool,
      shouldReturnFocusAfterClose: c.default.bool,
      preventScroll: c.default.bool,
      parentSelector: c.default.func,
      aria: c.default.object,
      data: c.default.object,
      role: c.default.string,
      contentLabel: c.default.string,
      shouldCloseOnEsc: c.default.bool,
      overlayRef: c.default.func,
      contentRef: c.default.func,
      id: c.default.string,
      overlayElement: c.default.func,
      contentElement: c.default.func
    }, w.defaultProps = {
      isOpen: !1,
      portalClassName: m,
      bodyOpenClassName: y,
      role: "dialog",
      ariaHideApp: !0,
      closeTimeoutMS: 0,
      shouldFocusAfterRender: !0,
      shouldCloseOnEsc: !0,
      shouldCloseOnOverlayClick: !0,
      shouldReturnFocusAfterClose: !0,
      preventScroll: !1,
      parentSelector: function parentSelector() {
        return document.body;
      },
      overlayElement: function overlayElement(e, t) {
        return o.default.createElement("div", e, t);
      },
      contentElement: function contentElement(e, t) {
        return o.default.createElement("div", e, t);
      }
    }, w.defaultStyles = {
      overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
      },
      content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
      }
    }, (0, et.polyfill)(w), "production" !== process.env.NODE_ENV && (w.setCreateHTMLElement = function (e) {
      return b = e;
    }), t.default = w;
  }),
      nt = l(f(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(tt);

    t.default = n.default, e.exports = t.default;
  }));

  var rt = function () {
    function e(e) {
      this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
    }

    var t = e.prototype;
    return t.insert = function (e) {
      if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
        var t,
            n = function (e) {
          var t = document.createElement("style");
          return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t;
        }(this);

        t = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(n, t), this.tags.push(n);
      }

      var r = this.tags[this.tags.length - 1];

      if (this.isSpeedy) {
        var o = function (e) {
          if (e.sheet) return e.sheet;

          for (var t = 0; t < document.styleSheets.length; t++) {
            if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
          }
        }(r);

        try {
          var a = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
          o.insertRule(e, a ? 0 : o.cssRules.length);
        } catch (t) {
          "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + e + '"', t);
        }
      } else r.appendChild(document.createTextNode(e));

      this.ctr++;
    }, t.flush = function () {
      this.tags.forEach(function (e) {
        return e.parentNode.removeChild(e);
      }), this.tags = [], this.ctr = 0;
    }, e;
  }();

  function ot(e) {
    function t(e, r, c, l, d) {
      for (var p, h, m, y, O, C = 0, E = 0, S = 0, k = 0, N = 0, P = 0, R = m = p = 0, F = 0, $ = 0, I = 0, U = 0, L = c.length, W = L - 1, V = "", q = "", H = "", z = ""; F < L;) {
        if (h = c.charCodeAt(F), F === W && 0 !== E + k + S + C && (0 !== E && (h = 47 === E ? 10 : 47), k = S = C = 0, L++, W++), 0 === E + k + S + C) {
          if (F === W && (0 < $ && (V = V.replace(f, "")), 0 < V.trim().length)) {
            switch (h) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                V += c.charAt(F);
            }

            h = 59;
          }

          switch (h) {
            case 123:
              for (p = (V = V.trim()).charCodeAt(0), m = 1, U = ++F; F < L;) {
                switch (h = c.charCodeAt(F)) {
                  case 123:
                    m++;
                    break;

                  case 125:
                    m--;
                    break;

                  case 47:
                    switch (h = c.charCodeAt(F + 1)) {
                      case 42:
                      case 47:
                        e: {
                          for (R = F + 1; R < W; ++R) {
                            switch (c.charCodeAt(R)) {
                              case 47:
                                if (42 === h && 42 === c.charCodeAt(R - 1) && F + 2 !== R) {
                                  F = R + 1;
                                  break e;
                                }

                                break;

                              case 10:
                                if (47 === h) {
                                  F = R + 1;
                                  break e;
                                }

                            }
                          }

                          F = R;
                        }

                    }

                    break;

                  case 91:
                    h++;

                  case 40:
                    h++;

                  case 34:
                  case 39:
                    for (; F++ < W && c.charCodeAt(F) !== h;) {
                      ;
                    }

                }

                if (0 === m) break;
                F++;
              }

              switch (m = c.substring(U, F), 0 === p && (p = (V = V.replace(u, "").trim()).charCodeAt(0)), p) {
                case 64:
                  switch (0 < $ && (V = V.replace(f, "")), h = V.charCodeAt(1)) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      $ = r;
                      break;

                    default:
                      $ = M;
                  }

                  if (U = (m = t(r, $, m, h, d + 1)).length, 0 < T && (O = i(3, m, $ = n(M, V, I), r, A, _, U, h, d, l), V = $.join(""), void 0 !== O && 0 === (U = (m = O.trim()).length) && (h = 0, m = "")), 0 < U) switch (h) {
                    case 115:
                      V = V.replace(w, s);

                    case 100:
                    case 109:
                    case 45:
                      m = V + "{" + m + "}";
                      break;

                    case 107:
                      m = (V = V.replace(v, "$1 $2")) + "{" + m + "}", m = 1 === j || 2 === j && a("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                      break;

                    default:
                      m = V + m, 112 === l && (q += m, m = "");
                  } else m = "";
                  break;

                default:
                  m = t(r, n(r, V, I), m, l, d + 1);
              }

              H += m, m = I = $ = R = p = 0, V = "", h = c.charCodeAt(++F);
              break;

            case 125:
            case 59:
              if (1 < (U = (V = (0 < $ ? V.replace(f, "") : V).trim()).length)) switch (0 === R && (p = V.charCodeAt(0), 45 === p || 96 < p && 123 > p) && (U = (V = V.replace(" ", ":")).length), 0 < T && void 0 !== (O = i(1, V, r, e, A, _, q.length, l, d, l)) && 0 === (U = (V = O.trim()).length) && (V = "\0\0"), p = V.charCodeAt(0), h = V.charCodeAt(1), p) {
                case 0:
                  break;

                case 64:
                  if (105 === h || 99 === h) {
                    z += V + c.charAt(F);
                    break;
                  }

                default:
                  58 !== V.charCodeAt(U - 1) && (q += o(V, p, h, V.charCodeAt(2)));
              }
              I = $ = R = p = 0, V = "", h = c.charCodeAt(++F);
          }
        }

        switch (h) {
          case 13:
          case 10:
            47 === E ? E = 0 : 0 === 1 + p && 107 !== l && 0 < V.length && ($ = 1, V += "\0"), 0 < T * D && i(0, V, r, e, A, _, q.length, l, d, l), _ = 1, A++;
            break;

          case 59:
          case 125:
            if (0 === E + k + S + C) {
              _++;
              break;
            }

          default:
            switch (_++, y = c.charAt(F), h) {
              case 9:
              case 32:
                if (0 === k + C + E) switch (N) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = "";
                    break;

                  default:
                    32 !== h && (y = " ");
                }
                break;

              case 0:
                y = "\\0";
                break;

              case 12:
                y = "\\f";
                break;

              case 11:
                y = "\\v";
                break;

              case 38:
                0 === k + E + C && ($ = I = 1, y = "\f" + y);
                break;

              case 108:
                if (0 === k + E + C + x && 0 < R) switch (F - R) {
                  case 2:
                    112 === N && 58 === c.charCodeAt(F - 3) && (x = N);

                  case 8:
                    111 === P && (x = P);
                }
                break;

              case 58:
                0 === k + E + C && (R = F);
                break;

              case 44:
                0 === E + S + k + C && ($ = 1, y += "\r");
                break;

              case 34:
              case 39:
                0 === E && (k = k === h ? 0 : 0 === k ? h : k);
                break;

              case 91:
                0 === k + E + S && C++;
                break;

              case 93:
                0 === k + E + S && C--;
                break;

              case 41:
                0 === k + E + C && S--;
                break;

              case 40:
                if (0 === k + E + C) {
                  if (0 === p) switch (2 * N + 3 * P) {
                    case 533:
                      break;

                    default:
                      p = 1;
                  }
                  S++;
                }

                break;

              case 64:
                0 === E + S + k + C + R + m && (m = 1);
                break;

              case 42:
              case 47:
                if (!(0 < k + C + S)) switch (E) {
                  case 0:
                    switch (2 * h + 3 * c.charCodeAt(F + 1)) {
                      case 235:
                        E = 47;
                        break;

                      case 220:
                        U = F, E = 42;
                    }

                    break;

                  case 42:
                    47 === h && 42 === N && U + 2 !== F && (33 === c.charCodeAt(U + 2) && (q += c.substring(U, F + 1)), y = "", E = 0);
                }
            }

            0 === E && (V += y);
        }

        P = N, N = h, F++;
      }

      if (0 < (U = q.length)) {
        if ($ = r, 0 < T && void 0 !== (O = i(2, q, $, e, A, _, U, l, d, l)) && 0 === (q = O).length) return z + q + H;

        if (q = $.join(",") + "{" + q + "}", 0 != j * x) {
          switch (2 !== j || a(q, 2) || (x = 0), x) {
            case 111:
              q = q.replace(g, ":-moz-$1") + q;
              break;

            case 112:
              q = q.replace(b, "::-webkit-input-$1") + q.replace(b, "::-moz-$1") + q.replace(b, ":-ms-input-$1") + q;
          }

          x = 0;
        }
      }

      return z + q + H;
    }

    function n(e, t, n) {
      var o = t.trim().split(m);
      t = o;
      var a = o.length,
          s = e.length;

      switch (s) {
        case 0:
        case 1:
          var i = 0;

          for (e = 0 === s ? "" : e[0] + " "; i < a; ++i) {
            t[i] = r(e, t[i], n).trim();
          }

          break;

        default:
          var c = i = 0;

          for (t = []; i < a; ++i) {
            for (var l = 0; l < s; ++l) {
              t[c++] = r(e[l] + " ", o[i], n).trim();
            }
          }

      }

      return t;
    }

    function r(e, t, n) {
      var r = t.charCodeAt(0);

      switch (33 > r && (r = (t = t.trim()).charCodeAt(0)), r) {
        case 38:
          return t.replace(y, "$1" + e.trim());

        case 58:
          return e.trim() + t.replace(y, "$1" + e.trim());

        default:
          if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(y, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
      }

      return e + t;
    }

    function o(e, t, n, r) {
      var s = e + ";",
          i = 2 * t + 3 * n + 4 * r;

      if (944 === i) {
        e = s.indexOf(":", 9) + 1;
        var c = s.substring(e, s.length - 1).trim();
        return c = s.substring(0, e).trim() + c + ";", 1 === j || 2 === j && a(c, 1) ? "-webkit-" + c + c : c;
      }

      if (0 === j || 2 === j && !a(s, 1)) return s;

      switch (i) {
        case 1015:
          return 97 === s.charCodeAt(10) ? "-webkit-" + s + s : s;

        case 951:
          return 116 === s.charCodeAt(3) ? "-webkit-" + s + s : s;

        case 963:
          return 110 === s.charCodeAt(5) ? "-webkit-" + s + s : s;

        case 1009:
          if (100 !== s.charCodeAt(4)) break;

        case 969:
        case 942:
          return "-webkit-" + s + s;

        case 978:
          return "-webkit-" + s + "-moz-" + s + s;

        case 1019:
        case 983:
          return "-webkit-" + s + "-moz-" + s + "-ms-" + s + s;

        case 883:
          if (45 === s.charCodeAt(8)) return "-webkit-" + s + s;
          if (0 < s.indexOf("image-set(", 11)) return s.replace(N, "$1-webkit-$2") + s;
          break;

        case 932:
          if (45 === s.charCodeAt(4)) switch (s.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + s.replace("-grow", "") + "-webkit-" + s + "-ms-" + s.replace("grow", "positive") + s;

            case 115:
              return "-webkit-" + s + "-ms-" + s.replace("shrink", "negative") + s;

            case 98:
              return "-webkit-" + s + "-ms-" + s.replace("basis", "preferred-size") + s;
          }
          return "-webkit-" + s + "-ms-" + s + s;

        case 964:
          return "-webkit-" + s + "-ms-flex-" + s + s;

        case 1023:
          if (99 !== s.charCodeAt(8)) break;
          return "-webkit-box-pack" + (c = s.substring(s.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + s + "-ms-flex-pack" + c + s;

        case 1005:
          return p.test(s) ? s.replace(d, ":-webkit-") + s.replace(d, ":-moz-") + s : s;

        case 1e3:
          switch (t = (c = s.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(t)) {
            case 226:
              c = s.replace(O, "tb");
              break;

            case 232:
              c = s.replace(O, "tb-rl");
              break;

            case 220:
              c = s.replace(O, "lr");
              break;

            default:
              return s;
          }

          return "-webkit-" + s + "-ms-" + c + s;

        case 1017:
          if (-1 === s.indexOf("sticky", 9)) break;

        case 975:
          switch (t = (s = e).length - 10, i = (c = (33 === s.charCodeAt(t) ? s.substring(0, t) : s).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
            case 203:
              if (111 > c.charCodeAt(8)) break;

            case 115:
              s = s.replace(c, "-webkit-" + c) + ";" + s;
              break;

            case 207:
            case 102:
              s = s.replace(c, "-webkit-" + (102 < i ? "inline-" : "") + "box") + ";" + s.replace(c, "-webkit-" + c) + ";" + s.replace(c, "-ms-" + c + "box") + ";" + s;
          }

          return s + ";";

        case 938:
          if (45 === s.charCodeAt(5)) switch (s.charCodeAt(6)) {
            case 105:
              return c = s.replace("-items", ""), "-webkit-" + s + "-webkit-box-" + c + "-ms-flex-" + c + s;

            case 115:
              return "-webkit-" + s + "-ms-flex-item-" + s.replace(E, "") + s;

            default:
              return "-webkit-" + s + "-ms-flex-line-pack" + s.replace("align-content", "").replace(E, "") + s;
          }
          break;

        case 973:
        case 989:
          if (45 !== s.charCodeAt(3) || 122 === s.charCodeAt(4)) break;

        case 931:
        case 953:
          if (!0 === k.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? o(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : s.replace(c, "-webkit-" + c) + s.replace(c, "-moz-" + c.replace("fill-", "")) + s;
          break;

        case 962:
          if (s = "-webkit-" + s + (102 === s.charCodeAt(5) ? "-ms-" + s : "") + s, 211 === n + r && 105 === s.charCodeAt(13) && 0 < s.indexOf("transform", 10)) return s.substring(0, s.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + s;
      }

      return s;
    }

    function a(e, t) {
      var n = e.indexOf(1 === t ? ":" : "{"),
          r = e.substring(0, 3 !== t ? n : 10);
      return n = e.substring(n + 1, e.length - 1), R(2 !== t ? r : r.replace(S, "$1"), n, t);
    }

    function s(e, t) {
      var n = o(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
      return n !== t + ";" ? n.replace(C, " or ($1)").substring(4) : "(" + t + ")";
    }

    function i(e, t, n, r, o, a, s, i, c, u) {
      for (var f, d = 0, p = t; d < T; ++d) {
        switch (f = P[d].call(l, e, p, n, r, o, a, s, i, c, u)) {
          case void 0:
          case !1:
          case !0:
          case null:
            break;

          default:
            p = f;
        }
      }

      if (p !== t) return p;
    }

    function c(e) {
      return void 0 !== (e = e.prefix) && (R = null, e ? "function" != typeof e ? j = 1 : (j = 2, R = e) : j = 0), c;
    }

    function l(e, n) {
      var r = e;

      if (33 > r.charCodeAt(0) && (r = r.trim()), r = [r], 0 < T) {
        var o = i(-1, n, r, r, A, _, 0, 0, 0, 0);
        void 0 !== o && "string" == typeof o && (n = o);
      }

      var a = t(M, r, n, 0, 0);
      return 0 < T && void 0 !== (o = i(-2, a, r, r, A, _, a.length, 0, 0, 0)) && (a = o), "", x = 0, _ = A = 1, a;
    }

    var u = /^\0+/g,
        f = /[\0\r\f]/g,
        d = /: */g,
        p = /zoo|gra/,
        h = /([,: ])(transform)/g,
        m = /,\r+?/g,
        y = /([\t\r\n ])*\f?&/g,
        v = /@(k\w+)\s*(\S*)\s*/,
        b = /::(place)/g,
        g = /:(read-only)/g,
        O = /[svh]\w+-[tblr]{2}/,
        w = /\(\s*(.*)\s*\)/g,
        C = /([\s\S]*?);/g,
        E = /-self|flex-/g,
        S = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
        k = /stretch|:\s*\w+\-(?:conte|avail)/,
        N = /([^-])(image-set\()/,
        _ = 1,
        A = 1,
        x = 0,
        j = 1,
        M = [],
        P = [],
        T = 0,
        R = null,
        D = 0;
    return l.use = function e(t) {
      switch (t) {
        case void 0:
        case null:
          T = P.length = 0;
          break;

        default:
          if ("function" == typeof t) P[T++] = t;else if ("object" == typeof t) for (var n = 0, r = t.length; n < r; ++n) {
            e(t[n]);
          } else D = 0 | !!t;
      }

      return e;
    }, l.set = c, void 0 !== e && c(e), l;
  }

  var at = function at(e) {
    var t = new WeakMap();
    return function (n) {
      if (t.has(n)) return t.get(n);
      var r = e(n);
      return t.set(n, r), r;
    };
  },
      st = "/*|*/";

  function it(e) {
    e && ft.current.insert(e + "}");
  }

  var ct,
      lt,
      ut,
      ft = {
    current: null
  },
      dt = function dt(e, t, n, r, o, a, s, i, c, l) {
    switch (e) {
      case 1:
        switch (t.charCodeAt(0)) {
          case 64:
            return ft.current.insert(t + ";"), "";

          case 108:
            if (98 === t.charCodeAt(2)) return "";
        }

        break;

      case 2:
        if (0 === i) return t + st;
        break;

      case 3:
        switch (i) {
          case 102:
          case 112:
            return ft.current.insert(n[0] + t), "";

          default:
            return t + (0 === l ? st : "");
        }

      case -2:
        t.split("/*|*/}").forEach(it);
    }
  },
      pt = function pt(e, t) {
    if (1 === e && 108 === t.charCodeAt(0) && 98 === t.charCodeAt(2)) return "";
  },
      ht = "undefined" != typeof document,
      mt = {},
      yt = ht ? void 0 : at(function () {
    var e = at(function () {
      return {};
    }),
        t = {},
        n = {};
    return function (r) {
      return void 0 === r || !0 === r ? t : !1 === r ? n : e(r);
    };
  });

  !function (e) {
    void 0 === e && (e = {});
    var t,
        n = e.key || "css";
    void 0 !== e.prefix && (t = {
      prefix: e.prefix
    });
    var r = new ot(t);
    if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(n)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
    var o,
        a,
        s = {};

    if (ht) {
      o = e.container || document.head;
      var i = document.querySelectorAll("style[data-emotion-" + n + "]");
      Array.prototype.forEach.call(i, function (e) {
        e.getAttribute("data-emotion-" + n).split(" ").forEach(function (e) {
          s[e] = !0;
        }), e.parentNode !== o && o.appendChild(e);
      });
    }

    if (ht) r.use(e.stylisPlugins)(dt), a = function a(e, t, n, o) {
      var a = t.name;

      if (ft.current = n, "production" !== process.env.NODE_ENV && void 0 !== t.map) {
        var s = t.map;
        ft.current = {
          insert: function insert(e) {
            n.insert(e + s);
          }
        };
      }

      r(e, t.styles), o && (f.inserted[a] = !0);
    };else {
      r.use(pt);
      var c = mt;
      (e.stylisPlugins || void 0 !== e.prefix) && (r.use(e.stylisPlugins), c = yt(e.stylisPlugins || mt)(e.prefix));

      a = function a(e, t, n, o) {
        var a = t.name,
            s = function (e, t) {
          var n = t.name;
          return void 0 === c[n] && (c[n] = r(e, t.styles)), c[n];
        }(e, t);

        return o && (f.inserted[a] = !0), "development" === process.env.NODE_ENV && void 0 !== t.map ? s + t.map : s;
      };
    }

    if ("production" !== process.env.NODE_ENV) {
      var l = /\/\*/g,
          u = /\*\//g;
      r.use(function (e, t) {
        switch (e) {
          case -1:
            for (; l.test(t);) {
              if (u.lastIndex = l.lastIndex, !u.test(t)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
              l.lastIndex = u.lastIndex;
            }

            l.lastIndex = 0;
        }
      }), r.use(function (e, t, n) {
        switch (e) {
          case -1:
            var r = t.match(/(:first|:nth|:nth-last)-child/g);
            r && !0 !== f.compat && r.forEach(function (e) {
              var n = new RegExp(e + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(t);
              e && !n && console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
            });
        }
      });
    }

    var f = {
      key: n,
      sheet: new rt({
        key: n,
        container: o,
        nonce: e.nonce,
        speedy: e.speedy
      }),
      nonce: e.nonce,
      inserted: s,
      registered: {},
      insert: a
    };
  }({
    stylisPlugins: [(ct = "#themed", lt = ct.trim() + " ", ut = new WeakSet(), function (e, t, n, r, o, a, s, i) {
      if (2 === e && 107 !== i && !ut.has(n)) {
        ut.add(n);

        for (var c = 0; c < n.length; c++) {
          n[c] = "" + lt + n[c];
        }
      }
    })]
  });
  var vt,
      bt,
      gt,
      Ot = a.default.createContext({
    style: {},
    variables: {},
    cssVariables: {}
  });

  function wt() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    return e.filter(function (e) {
      return e;
    }).join(" ");
  }

  function Ct() {
    return (Ct = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  r.css(gt || (vt = ["\n  svg {\n    fill: currentColor;\n  }\n"], bt = ["\n  svg {\n    fill: currentColor;\n  }\n"], Object.defineProperty ? Object.defineProperty(vt, "raw", {
    value: bt
  }) : vt.raw = bt, gt = vt));

  var Et = function Et(_ref) {
    var _ref$styles = _ref.styles,
        e = _ref$styles === void 0 ? {} : _ref$styles,
        t = _objectWithoutProperties(_ref, ["styles"]);

    return a.default.createElement("svg", Ct({
      className: (e["ef-icon"] || "ef-icon") + " " + (e["ef-svg"] || "ef-svg"),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      width: "32",
      height: "32"
    }, t), a.default.createElement("path", {
      className: e["cls-1"] || "cls-1",
      d: "M25.29 27a1 1 0 01-.7-.29L5.29 7.41a1 1 0 010-1.41L6 5.29a1 1 0 011.41 0l19.3 19.3a1 1 0 010 1.41l-.71.71a1 1 0 01-.71.29z"
    }), a.default.createElement("path", {
      className: e["cls-1"] || "cls-1",
      d: "M6.71 27a1 1 0 01-.71-.29L5.29 26a1 1 0 010-1.41l19.3-19.3a1 1 0 011.41 0l.71.71a1 1 0 010 1.41l-19.3 19.3a1 1 0 01-.7.29z"
    }));
  },
      St = function St(e) {
    var t = e.className,
        n = c(e, ["className"]);
    return a.default.createElement(Et, _i({
      className: ["ef-icon ef-svg", t].join(" ")
    }, n));
  };

  St.displayName = "IconClose";

  var kt = function kt(e) {
    var n = e.children,
        r = e.open,
        o = e.onDismiss,
        s = e.lightbox,
        l = e.task,
        u = e.size,
        f = e.top,
        d = e.bottom,
        p = e.className,
        h = c(e, ["children", "open", "onDismiss", "lightbox", "task", "size", "top", "bottom", "className"]),
        m = t.useContext(Ot).style,
        y = void 0 === m ? {} : m,
        v = {
      modal: wt("ef-modal", l ? "-task" : "", u && -1 !== ["s", "m", "l", "xl"].indexOf(u) && "-" + u || "", f && "-top", d && "-bottom", p || "", s ? "" : "ef-surface -rounded -shadow"),
      overlay: {
        base: wt("ef-modal__overlay", s ? "-lightbox" : "", l ? "-task" : ""),
        afterOpen: "ef-modal__overlay--after-open",
        beforeClose: "ef-modal__overlay--before-close"
      },
      html: "ef-modal--active"
    };
    return t.useEffect(function () {
      nt.setAppElement(window.document.body);
    }, []), a.default.createElement(nt, _i({
      css: y.Modal,
      className: v.modal,
      isOpen: r,
      onRequestClose: o,
      overlayClassName: v.overlay,
      closeTimeoutMS: 200,
      htmlOpenClassName: v.html
    }, h), a.default.createElement("button", {
      className: "ef-modal__dismiss",
      onClick: o
    }, a.default.createElement(St, null)), n);
  };

  kt.Content = function (e) {
    var n = e.children,
        r = e.className,
        o = c(e, ["children", "className"]),
        s = t.useContext(Ot).style,
        l = void 0 === s ? {} : s,
        u = wt("ef-modal__content", r || "");
    return a.default.createElement("div", _i({
      css: l.ModalContent,
      className: u
    }, o), n);
  }, kt.Header = function (e) {
    var t = e.children,
        n = e.className,
        r = c(e, ["children", "className"]),
        o = wt("ef-modal__header", n || "");
    return a.default.createElement("div", _i({
      className: o
    }, r), t);
  }, kt.Footer = function (e) {
    var t = e.children,
        n = e.className,
        r = c(e, ["children", "className"]),
        o = wt("ef-modal__footer", n || "");
    return a.default.createElement("div", _i({
      className: o
    }, r), t);
  }, kt.Title = function (e) {
    var t = e.children,
        n = e.className,
        r = c(e, ["children", "className"]),
        o = wt("ef-modal__title", n || "");
    return a.default.createElement("h6", _i({
      className: o
    }, r), t);
  }, e.Modal = kt, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});